import React from 'react';
import './Footer.css';
import { useSiteConfig } from '../../../app/providers/SiteConfigProvider';

const Footer = () => {
  const { config, loading, error } = useSiteConfig();


  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <a href="#" className="logo">
            <img
              alt="Logo del Ayuntamiento de Almassora"
              src={config.logoFooter}
              height="80px"
            />
          </a>
        </div>
        <div className="footer-section">
          <ul className="footer-list">
            <li>{config.direccion}</li>
            <li>
              <a href={`tel:${config.telefono}`}>{config.telefono}</a>
            </li>
            <li>
              <a href={`mailto:${config.correoElectronico}`}>
                {config.correoElectronico}
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <ul className="footer-list">
            {config.enlaces.map((enlace, index) => (
              <li key={index}>
                <a href={enlace.url}>{enlace.nombre}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;